<template>
  <div class="entry-page">
    <div class="my-entry-list" @click="goEntryList">
      我的参赛
    </div>
    <div class="img" style="margin: 16px 12px 0; border-radius: 8px; overflow: hidden">
      <img :src="imgView(match.backgroundImage2)" alt="" style="width: 100%">
    </div>
    <div class="match">
      <div class="info">
        <div class="left">
          <van-image :src="(match.icon && match.icon.length === 28) ? imgView(match.icon) : ''" width="36px" height="36px" radius="8px"></van-image>
        </div>
        <div class="right">
          <div class="title">
            <span>{{match.chineseName}}</span>
          </div>
          <div class="address">
            <img src="../../assets/date.png" style="width: 16px; height: 16px;">
            <div style="margin-left: 4px">{{ getFormatDate(match.beginDate) }} ~ {{ getFormatDate(match.endDate) }}</div>
          </div>
          <div class="address" style="margin-top: 4px;">
            <img src="../../assets/position.png" style="width: 16px; height: 16px;">
            <div style="margin-left: 4px; overflow:hidden; white-space: nowrap; text-overflow: ellipsis; -o-text-overflow:ellipsis;">
              {{ match.province || '' }}-{{ match.city || '' }}&nbsp;{{ match.location || '' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-tabs v-model="active" @click="changed" background="#F6F6F8" :swipeable="true">
      <van-tab title="日程安排">
        <div class="schedule">
          <div class="title">
            <img src="../../assets/schedule/ready.png" style="width: 24px; height: 24px;" alt="">
            <div class="info">赛事筹备阶段</div>
          </div>
          <div class="box" style="height: 24px;"></div>
          <div class="title">
            <img src="../../assets/schedule/entry.png" style="width: 24px; height: 24px;" alt="">
            <div class="info">报名阶段</div>
          </div>
          <div class="box" style="height: 84px;">
            <div class="date">
              <div class="row">
                <span class="left">开始：</span>
                <span class="right">{{ getFormatDate(match.regBeginDate, '{y}-{m}-{d}') }}</span>
              </div>
              <div class="row">
                <span class="left">结束：</span>
                <span class="right">{{ getFormatDate(match.regEndDate, '{y}-{m}-{d}') }}</span>
              </div>
            </div>
          </div>
          <div class="title">
            <img src="../../assets/schedule/entryAdjust.png" style="width: 24px; height: 24px;" alt="">
            <div class="info">报名调整结束</div>
          </div>
          <div class="box" style="height: 58px;">
            <div class="date">
              <div class="row">
                <span class="left">结束：</span>
                <span class="right">{{ getFormatDate(match.regUpdateEndDate, '{y}-{m}-{d} {h}:{i}') }}</span>
              </div>
            </div>
          </div>
          <div class="title">
            <img src="../../assets/schedule/begin.png" style="width: 24px; height: 24px;" alt="">
            <div class="info">比赛阶段</div>
          </div>
          <div class="box" style="height: 84px;">
            <div class="date">
              <div class="row">
                <span class="left">开始：</span>
                <span class="right">{{ getFormatDate(match.beginDate, '{y}-{m}-{d}') }}</span>
              </div>
              <div class="row">
                <span class="left">结束：</span>
                <span class="right">{{ getFormatDate(match.endDate, '{y}-{m}-{d}') }}</span>
              </div>
            </div>
          </div>
          <div class="title">
            <img src="../../assets/schedule/end.png" style="width: 24px; height: 24px;" alt="">
            <div class="info">赛事结束</div>
          </div>
        </div>
      </van-tab>
      <van-tab title="比赛规程">
        <div style="padding: 0 20px; width: 100vw; box-sizing: border-box">
          <div id="regulations" style="transform-origin: left top;"></div>
        </div>
      </van-tab>
    </van-tabs>
    <div style="height: 90px;"></div>
    <div class="bottom">
      <van-button type="info" block round @click="goProjectList" :disabled="disabled" style="background-color: #191919;">
        <span style="font-size: 16px; color: #FFFFFF">{{ buttonInfo }}</span>
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Image as VanImage, Tab, Tabs, Button } from 'vant'
Vue.use(Toast).use(VanImage).use(Tabs).use(Tab).use(Button)
import {getBMMatchList, getBMUnionMatch} from '@/api/match'
import {DateUtil, QNImageUtil} from '@/utils'

export default {
  data() {
    return {
      unionMatchId: '',
      match: {},
      active: 0,
      buttonInfo: '参赛报名',
      disabled: false,
      list: []
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId
    if (this.unionMatchId) {
      this.getBMUnionMatch()
      this.getBMMatchList()
    } else {
      Toast.fail('缺少赛事信息')
    }
  },
  methods: {
    getBMMatchList() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMMatchList(params).then(res => {
        if (res) {
          const data = res.data
          this.list = data.list
        }
      })
    },
    goEntryList() {
      this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          const match = this.match
          if (match.regBeginDate && new Date(match.regBeginDate).getTime() > new Date().getTime()) {
            this.buttonInfo = '离报名开始还剩' + Math.ceil((new Date(match.regBeginDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24)  + '天'
            this.disabled = true
          } else if (match.regEndDate && new Date(match.regEndDate).getTime() < new Date().getTime()){
            this.buttonInfo = '报名已结束，查看赛事公告'
          }
          this.$nextTick(() => {
            const regulations = document.getElementById('regulations')
            if (regulations) {
              regulations.innerHTML = this.match.regulations || ''
            }
          })
        }
      })
    },
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getFormatDate(date, type) {
      if (!type) type = '{y}-{m}-{d}'
      return DateUtil.parseDateTime(date, type)
    },
    changed() {
      if (this.active === 1) {
        this.$nextTick(() => {
          const regulations = document.getElementById('regulations')
          if (regulations) {
            regulations.innerHTML = this.match.regulations || ''
          }
        })
      }
    },
    goProjectList() {
      if (this.match.regEndDate && new Date(this.match.regEndDate).getTime() < new Date().getTime()) {
        this.$router.push('/union-match?unionMatchId=' + this.unionMatchId)
        return
      }
      if (this.list.length === 1 && !(this.list[0].publicSignUp === 0 && this.list[0].allowTeamSignup === 1) && (this.list[0].teamLimitCount - this.list[0].teamCount > 0)) {
        this.goEntry(this.list[0])
      } else {
        localStorage.setItem('entry-match', JSON.stringify(this.match))
        this.$router.push('/entry-page/project-list?unionMatchId=' + this.unionMatchId)
      }
    },
    goEntry(project) {
      if (project.unitType === 0) {
        this.$router.push('/entry-page/entry-info?unionMatchId=' + this.unionMatchId +'&matchId=' + project.id)
      } else if (project.unitType === 1) {
        this.$router.push('/entry-page/entry-info-person?unionMatchId=' + this.unionMatchId +'&matchId=' + project.id)
      } else {
        this.$router.push('/entry-page/entry-info-more?unionMatchId=' + this.unionMatchId +'&matchId=' + project.id)
      }
    }
  }
}
</script>

<style lang="scss">
.entry-page {
  min-height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  .my-entry-list {
    z-index: 999;
    position: fixed;
    top: 26px;
    right: 0;
    width: 72px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px 0 0 12px;
    background-color: #191919;
    color: #FFFFFF;
    font-size: 12px;
  }
  .match {
    background-color: #fff;
    border-radius: 4px 4px 8px 8px;
    margin-bottom: 12px;
    .info {
      margin: 0 16px;
      padding: 16px 0 12px 0;
      display: flex;
      flex-flow: row;
      .left {
        text-align: center;
        width: 44px;
        .care {
          width: 44px;
          height: 20px;
          border-radius: 2px;
          background-color: #BEF002;
          color: #191919;
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          margin-top: 12px;
        }
      }
      .right {
        width: calc(100% - 36px);
        padding-left: 12px;
        box-sizing: border-box;
        .title {
          height: 48px;
          font-size: 18px;
          font-weight: 500;
          color: #191919;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .address {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
        }
        .size-count {
          margin-top: 4px;
          display: flex;
          flex-flow: row;
          font-size: 12px;
          color: #474747;
          .count {
            margin-left: 12px;
          }
        }
      }
    }
  }
  .schedule {
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    padding: 14px 12px;
    .title {
      margin: 8px;
      display: flex;
      align-items: center;
      .info {
        color: #282828;
        font-size: 12px;
        margin-left: 8px;
      }
    }
    .box {
      margin-left: 19px;
      padding-left: 19px;
      border-left: 1px #8C8C8C dashed;
      .date {
        padding: 16px 12px;
        background-color: #FAFAFC;
        .row {
          font-size: 14px;
          .left {
            color: #10161E;
          }
          .right {
            color: #8C8C8C;
          }
        }
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 16px 12px 12px 8px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
.wscnph{
  max-width: 100%;
}
</style>
